import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import Library from '../Library';
import { selectClassroom } from '../Classrooms';
import SpinnerOverlay from '../SpinnerOverlay';
import { RootState } from '../ApplicationState';

const LibraryRedirect = () => {
  const classroom = useSelector((state: RootState) => {
    const selectedClassroom = selectClassroom(state);
    return selectedClassroom;
  });

  return (
    <Fragment key={'library selector'}>
      {classroom === undefined ? <SpinnerOverlay isShow /> : <Library grade={classroom.grade} />}
    </Fragment>
  );
};

export default LibraryRedirect;
